import React, { useContext, useState } from "react";
import { Form, Input, Button, message } from "antd";
import {
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleOutlined,
} from "@ant-design/icons";
import "./style.css";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../../Assets/Images/Logo.png";
import logoDark from "../../../Assets/icons/Sidebaricon/Logo Dark.svg";
import { updatePassword } from "../../../API/auth";
import { ThemeContext } from "../../../Contexts/ThemeProvider";

const CreateNewPassword = () => {
  const [loading, setLoading] = useState(false);
  const { isDarkMode } = useContext(ThemeContext);
  const navigate = useNavigate();
  const { id } = useParams();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await updatePassword(id, values?.password);
      if (Math.floor(response.status / 100) === 2) {
        navigate("/passwordchanged");
      } else {
        message.error("Invalid Password");
      }
    } catch (error) {
      console.error("Failed to perform the necessary action", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="create-page">
      <div className="logo">
        <img src={isDarkMode ? logoDark : logo} alt="Company Logo" />
      </div>

      <div className="create">
        <div className="create-card">
          <div className="title">
            <div className="main">Create New Password</div>
            <div className="sub">
              Don't worry! It occurs. Please enter the email address linked with
              your account.
            </div>
          </div>

          <Form
            name="create"
            className="create-form"
            onFinish={onFinish}
            layout="vertical"
          >
            <div className="placeholders-heading">New Password</div>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please input your new password!" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Type Password"
                minLength={8}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <div className="placeholders-heading">Confirm Password</div>
            <Form.Item
              name="confirmPassword"
              dependencies={["password"]}
              rules={[
                { required: true, message: "Please confirm your password!" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
            >
              <Input.Password
                prefix={<LockOutlined className="site-form-item-icon" />}
                placeholder="Confirm Password"
                minLength={8}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                }
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="default"
                htmlType="submit"
                className="create-form-button"
                loading={loading}
              >
                Create New Password
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default CreateNewPassword;
